import type { FaqResponse } from '@acme/domains';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
  Button,
} from 'flowbite-react';

export interface FaqAccordionProps {
  faqs: FaqResponse[];
  onViewAll?: () => void;
}

export const FaqAccordion: React.FC<FaqAccordionProps> = ({
  faqs,
  onViewAll,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-start justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Частые вопросы</h2>
        {onViewAll && (
          <Button color="alternative" onClick={onViewAll}>
            Посмотреть все
          </Button>
        )}
      </div>

      {faqs.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          Нет доступных вопросов
        </div>
      ) : (
        <Accordion collapseAll>
          {faqs.map((faq, index) => (
            <AccordionPanel key={faq.id || index}>
              <AccordionTitle className="text-base font-medium text-gray-900 hover:bg-gray-100 focus:ring-0">
                {faq.question || 'Вопрос'}
              </AccordionTitle>
              <AccordionContent className="bg-white border-x border-gray-200">
                <p className="text-base text-gray-500 leading-6">
                  {faq.answer || 'Ответ отсутствует'}
                </p>
              </AccordionContent>
            </AccordionPanel>
          ))}
        </Accordion>
      )}
    </div>
  );
};
